<template>
  <b-dropdown v-model="current" v-if="recipe.serving_count > 0 && items.length > 0">
    <button class="button is-white" slot="trigger">
      <span>{{ current }} {{ servingName | pluralize(current) }}</span>
      <b-icon icon="chevron-down" size="is-small" type="is-primary"/>
    </button>

    <b-dropdown-item v-for="amount in items" :key="amount" :value="amount">
      {{ amount }} {{ servingName | pluralize(amount) }}
    </b-dropdown-item>

    <hr class="dropdown-divider" v-if="minimumExplanation || maximumExplanation">

    <a class="media serving-info dropdown-item" @click.stop="showMinimumExplanation" v-if="minimumExplanation">
      <b-icon class="media-left" icon="question-circle-o"/>
      <div class="media-content">
        {{ $t('why not less?') }}
      </div>
    </a>
    <a class="media serving-info dropdown-item" @click.stop="showMaximumExplanation" v-if="maximumExplanation">
      <b-icon class="media-left" icon="question-circle-o"/>
      <div class="media-content">
        {{ $t('why not more?') }}
      </div>
    </a>
  </b-dropdown>
  <button class="button is-white no-dropdown" disabled v-else-if="recipe.serving_count">
    <span>{{ current }} {{ servingName | pluralize(current) }}</span>
  </button>
</template>

<script>
import SHARED from './shared'

export default {
  data(){
    return SHARED
  },

  computed: {
    items(){
      const min = this.recipe.serving_minimum || 1
      const max = this.recipe.serving_maximum || 10
      const steps = this.recipe.serving_steps || 1

      const items = []
      for(let i = min; i <= max; i += steps){
        items.push(i)
      }
      return items
    },

    servingName(){
      if(!this.recipe || !this.recipe.serving_type) return ''
      return this.recipe.serving_type.name
    },

    minimumExplanation(){
      return this.recipe.serving_minimum_description
    },
    maximumExplanation(){
      return this.recipe.serving_maximum_description
    }
  },

  methods: {
    showMinimumExplanation(){
      this.$dialog.alert(this.minimumExplanation)
    },

    showMaximumExplanation(){
      this.$dialog.alert(this.maximumExplanation)
    }
  }
}
</script>

<i18n>
{
  "de_at": {
    "why not less?": "Warum nicht weniger?",
    "why not more?": "Warum nicht mehr?"
  },
  "cs": {
    "why not less?": "Proč ne méně?",
    "why not more?": "Proč ne?"
  },
  "hu": {
    "why not less?": "Miért ne kevesebbet?",
    "why not more?": "Miért ne?"
  },
  "fr": {
    "why not less?": "Pourquoi pas moins?",
    "why not more?": "Pourquoi pas?"
  }
}
</i18n>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ingredients/ServingSelector.vue